import { Pending, ValidatedDropDownList } from '@finbeat/react-toolkit';
import { getProcedureParams } from 'axios/tariffsApi';
import BaseReactHookFormValue from 'base-components/BaseReactHookForm/BaseReactHookFormValue';
import useApi from 'hooks/useApi';
import { TariffsInfo } from 'models/api/tariff';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useQuery } from 'react-query';
import './TariffsModal.scss';

const TariffsModalProcedureParams = ({
    periodIdx,
    disabled,
}: {
    periodIdx: number;
    disabled: boolean;
}) => {
    const api = useApi();
    const { watch, setValue } = useFormContext<TariffsInfo>();
    const { fields } = useFieldArray<TariffsInfo>({
        name: `periods.${periodIdx}.proceduresParams`,
    });

    const id = watch(`periods.${periodIdx}.id`);
    const proceduresDefId = watch(`periods.${periodIdx}.proceduresDefId`);

    const { isFetching } = useQuery(
        ['getProcedureParams', id, proceduresDefId],
        () => getProcedureParams(api, id, proceduresDefId),
        {
            onSuccess: (data) => setValue(`periods.${periodIdx}.proceduresParams`, data),
        }
    );

    return isFetching ? (
        <Pending />
    ) : (
        <table className="table table-bordered">
            <tbody>
                {fields.map((x, idx) => (
                    <Param key={x.id} periodIdx={periodIdx} idx={idx} disabled={disabled} />
                ))}
            </tbody>
        </table>
    );
};

const Param = ({
    key,
    periodIdx,
    idx,
    disabled,
}: {
    key: string;
    periodIdx: number;
    idx: number;
    disabled: boolean;
}) => {
    const className = 'procedure-param';
    const { watch } = useFormContext<TariffsInfo>();
    const paramList = watch(`periods.${periodIdx}.proceduresParams.${idx}.paramList`);

    return (
        <tr className={className} key={key}>
            <td>
                <BaseReactHookFormValue<TariffsInfo>
                    name={`periods.${periodIdx}.proceduresParams.${idx}.procedureName`}
                />
            </td>
            <td>
                <ValidatedDropDownList<TariffsInfo>
                    items={paramList}
                    name={`periods.${periodIdx}.proceduresParams.${idx}.procedureDefParamsId`}
                    disabled={disabled}
                />
            </td>
        </tr>
    );
};

export default TariffsModalProcedureParams;
